import { AgentFinanceWebService } from '@linktivity/gds-neo';

export const InvoiceStatus =
  AgentFinanceWebService.ListInvoicesWithPageInvoiceStatusEnum;

export const InvoiceType =
  AgentFinanceWebService.ListInvoicesWithPageInvoiceTypeEnum;
export type InvoiceType = AgentFinanceWebService.InvoiceType;

export const WalletOrderType = AgentFinanceWebService.WalletOrderType;

export const ListWalletOrderFormatTypeEnum =
  AgentFinanceWebService.ListWalletOrderFormatTypeEnum;

export const ListWalletOrdersTypeEnum =
  AgentFinanceWebService.ListWalletOrdersTypeEnum;
